var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "createTrip"
  }, [(_vm.startTrip == false) ? _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Create Trip")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Back to Trip List"
    },
    on: {
      "click": _vm.showTripMgmt
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "style": "font-size:18px"
    }
  })])])])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "0.2rem"
    }
  }, [_c('span', [_vm._v("Adhoc Vehicle Req. ID : " + _vm._s(this.vehiclerequestid))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "0.2rem"
    }
  }, [_c('span', [_vm._v("Trip ID : " + _vm._s(_vm.tmstripid))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "0.2rem"
    }
  }, [_c('span', [_vm._v("Trip Status : " + _vm._s(_vm.tripStatus == 'created' ? 'Created' : _vm.tripStatus == 'start' ? 'Started' : _vm.tripStatus == 'closed' ? 'Closed' : _vm.tripStatus == 'completed' ? 'Completed' : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "row position"
  }, [_c('div', [_c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button",
      "disabled": !_vm.tripData || _vm.tripData.tripstatus == 'start' || _vm.tripStatus == 'closed' || _vm.tripStatus == 'completed'
    },
    on: {
      "click": function($event) {
        _vm.checkRestrictionErr('start')
      }
    }
  }, [_vm._v("Start Trip")]), _vm._v("   \n       ")])], 1), _vm._v(" "), _c('div', [(_vm.expanded == false) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Expand All"
    },
    on: {
      "click": _vm.expandAll
    }
  }, [_vm._v("\n       Expand All "), _c('i', {
    staticClass: "fa fa-plus-circle"
  })]) : _vm._e(), _vm._v(" "), (_vm.expanded == true) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Collapse All"
    },
    on: {
      "click": _vm.collapseAll
    }
  }, [_vm._v("\n       Collapse All "), _c('i', {
    staticClass: "fa fa-minus-circle"
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "AssignedBA/SR",
      "id": "chck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck1"
    }
  }, [_vm._v("Assign BA/SR And Vehicle"), _c('span', [_vm._v("Total Vehicle Capacity (kg): " + _vm._s(_vm.VehicleCapacity))]), _vm._v("  "), _c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v("Assigned Load (kg): " + _vm._s(_vm.assignedLoad))]), _vm._v("  "), _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("Available Capacity (kg): " + _vm._s(_vm.AvailaibleCapacity.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Assigned To")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-gear' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "disabled": _vm.tripStatus == 'closed' || _vm.tripID != '' || _vm.srdisabled == true,
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.srUserList,
      "placeholder": "Select User",
      "append-to-body": true,
      "name": "srUserId"
    },
    on: {
      "select": _vm.selectSRUser,
      "input": _vm.selectSRUserKeyUp
    },
    model: {
      value: (_vm.srUserId),
      callback: function($$v) {
        _vm.srUserId = $$v
      },
      expression: "srUserId"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.srUserErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("ADD Helper")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-gear' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "disabled": _vm.tripStatus == 'closed' || _vm.tripID != '' || _vm.disablehelper,
      "multiple": true,
      "max-height": 200,
      "clearable": false,
      "options": _vm.srHelperList,
      "placeholder": "Select Helper",
      "clear-on-select": true,
      "valueFormat": "object",
      "append-to-body": true,
      "name": "srHelperId"
    },
    on: {
      "select": _vm.selectSRHelper
    },
    model: {
      value: (_vm.srHelperId),
      callback: function($$v) {
        _vm.srHelperId = $$v
      },
      expression: "srHelperId"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.srHelperErr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', [_c('label', [_vm._v("Contracted Vehicle Number")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-gear' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "disabled": _vm.AdHocVehicle || _vm.tripStatus == 'closed' || _vm.tripID != '',
      "options": _vm.ContractedVehiclelist,
      "placeholder": "Select a Vehicle",
      "append-to-body": true,
      "name": "ContractedVehicle"
    },
    on: {
      "select": _vm.selectedContractedVehicle
    },
    model: {
      value: (_vm.ContractedVehicle),
      callback: function($$v) {
        _vm.ContractedVehicle = $$v
      },
      expression: "ContractedVehicle"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.vehicleErr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', [_c('label', [_vm._v("Ad-hoc Vehicle Model")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-gear' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "disabled": _vm.AdHocVehicle == false || _vm.tripStatus == 'closed' || _vm.tripID != '' || _vm.updateAdHocVehicleflag == true,
      "options": _vm.VehicleModellist,
      "placeholder": "Vehicle Model",
      "append-to-body": true,
      "name": "VehicleModel"
    },
    on: {
      "select": _vm.selectedVehicleModel
    },
    model: {
      value: (_vm.VehicleModel),
      callback: function($$v) {
        _vm.VehicleModel = $$v
      },
      expression: "VehicleModel"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.vehicleModelErr))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: " row checkbox",
    staticStyle: {
      "padding": "30px 0px 0px 0px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AdHocVehicle),
      expression: "AdHocVehicle"
    }],
    attrs: {
      "disabled": _vm.tripStatus == 'closed' || _vm.tripID != '' || _vm.userType == 'TSP BA' || _vm.updateAdHocVehicleflag == true,
      "type": "checkbox",
      "id": "AdHocVehicle",
      "name": "AdHocVehicle"
    },
    domProps: {
      "checked": Array.isArray(_vm.AdHocVehicle) ? _vm._i(_vm.AdHocVehicle, null) > -1 : (_vm.AdHocVehicle)
    },
    on: {
      "click": _vm.clearDataForAdHocVehicle,
      "__c": function($event) {
        var $$a = _vm.AdHocVehicle,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.AdHocVehicle = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.AdHocVehicle = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.AdHocVehicle = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "1"
    }
  }, [_vm._v("Ad-hoc Vehicle")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-top": "2rem"
    }
  }, [_c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wheeler),
      expression: "wheeler"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "disabled": _vm.AdHocVehicle == false || _vm.tripStatus == 'closed' || _vm.tripID != '' || _vm.updateAdHocVehicleflag == true,
      "type": "radio",
      "id": "2W",
      "value": "2",
      "name": "W"
    },
    domProps: {
      "checked": _vm._q(_vm.wheeler, "2")
    },
    on: {
      "__c": function($event) {
        _vm.wheeler = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "2W"
    }
  }, [_vm._v("2W ")]), _vm._v("     \n              "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wheeler),
      expression: "wheeler"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "disabled": _vm.AdHocVehicle == false || _vm.tripStatus == 'closed' || _vm.tripID != '' || _vm.updateAdHocVehicleflag == true,
      "type": "radio",
      "id": "4W",
      "value": "4",
      "name": "W"
    },
    domProps: {
      "checked": _vm._q(_vm.wheeler, "4")
    },
    on: {
      "__c": function($event) {
        _vm.wheeler = "4"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "4W"
    }
  }, [_vm._v("4W")]), _vm._v("     \n            ")])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.WheelErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Ad-hoc Vehicle Number")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adHocVehicleNumber),
      expression: "adHocVehicleNumber"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "disabled": _vm.AdHocVehicle == false || _vm.tripStatus == 'closed' || _vm.tripID != '',
      "type": "text",
      "name": "adHocVehicleNumber",
      "id": "adHocVehicleNumber"
    },
    domProps: {
      "value": (_vm.adHocVehicleNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.adHocVehicleNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "vehiclenote"
    }
  }, [_vm._v("Note: Allowed Vehicle Number Format 'XX 00 XX 0000' or 'XX 00 X 0000'.")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.vehicleNoErr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Ad-hoc Vehicle Cost")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adHocVehicleCost),
      expression: "adHocVehicleCost"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "disabled": _vm.AdHocVehicle == false || _vm.tripStatus == 'closed' || _vm.tripID != '' || _vm.updateAdhocVehicleCost == false,
      "type": "text",
      "name": "adHocVehicleCost",
      "id": "adHocVehicleCost"
    },
    domProps: {
      "value": (_vm.adHocVehicleCost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.adHocVehicleCost = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "10px"
    }
  }, [_c('label', [_vm._v("User Type : " + _vm._s(this.userType))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px 0px 0px 6px"
    }
  }, [_c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.tripStatus == 'closed' || _vm.tripID != '',
      "title": "Save"
    },
    on: {
      "click": function($event) {
        _vm.checkRestrictionErr('create')
      }
    }
  }, [_vm._v("Save and Next "), _c('i', {
    staticClass: "fa fa-save"
  })])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[3]),
      expression: "accordianTab[3]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "Shipments",
      "id": "chck3"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[3]) ? _vm._i(_vm.accordianTab[3], null) > -1 : (_vm.accordianTab[3])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(3)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck3"
    }
  }, [_vm._v("Add Shipments "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.addShipmentTabErr))])]), _vm._v(" "), (_vm.showAddShipment) ? _c('div', {
    staticClass: "tab-content"
  }, [(_vm.tripID) ? _c('add-shipments', {
    attrs: {
      "parentOBj": _vm.allocationData,
      "VehicleCapacity": _vm.VehicleCapacity,
      "pocAutoFlag": _vm.autoallocatepocflag
    },
    on: {
      "setTripData": _vm.setTripData
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[4]),
      expression: "accordianTab[4]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "Shipments",
      "id": "chck4"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[4]) ? _vm._i(_vm.accordianTab[4], null) > -1 : (_vm.accordianTab[4])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(4)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[4],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[4] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[4] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 4, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck4"
    }
  }, [_vm._v("Add Requested Pickups\n          "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.addpickuprequesterr))])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.tripID) ? _c('div', {
    staticClass: "card-header-tab",
    on: {
      "setTripData": _vm.setTripData
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('button', {
      key: tab.key,
      class: ['tab-button ', {
        active: _vm.currentTab === tab.key
      }],
      attrs: {
        "title": tab.value
      },
      on: {
        "click": function($event) {
          _vm.onTabClick(tab.key)
        }
      }
    }, [_vm._v("\n              " + _vm._s(tab.value) + "\n              "), (tab.value == 'Pickups') ? _c('span', {
      attrs: {
        "id": "second"
      }
    }, [_c('i', {
      staticClass: "fa fa-truck"
    })]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), _c('b-card', [(_vm.currentTab == 'First') ? _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.pickupexpanded == false) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Expand All"
    },
    on: {
      "click": _vm.pickupexpandAll
    }
  }, [_vm._v("\n                    Expand All "), _c('i', {
    staticClass: "fa fa-plus-circle"
  })]) : _vm._e(), _vm._v(" "), (_vm.pickupexpanded == true) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Collapse All"
    },
    on: {
      "click": _vm.pickupcollapseAll
    }
  }, [_vm._v("\n                    Collapse All "), _c('i', {
    staticClass: "fa fa-minus-circle"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTabpickup[1]),
      expression: "accordianTabpickup[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "Notaddedtothetrip",
      "id": "pickupchck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTabpickup[1]) ? _vm._i(_vm.accordianTabpickup[1], null) > -1 : (_vm.accordianTabpickup[1])
    },
    on: {
      "click": function($event) {
        _vm.PickuptoggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTabpickup[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTabpickup[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTabpickup[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTabpickup, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "pickupchck1"
    }
  }, [_vm._v("Not added to the trip(" + _vm._s(this.totalCount) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse",
      modifiers: {
        "collapse": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true",
      "title": "Search Filter"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Pickup Request ID ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickuprequest),
      expression: "pickuprequest"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "pickuprequest",
      "placeholder": "Pickup Request"
    },
    domProps: {
      "value": (_vm.pickuprequest)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnly($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pickuprequest = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Client Short/ Display Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.companyNamelist,
      "placeholder": "Select Client",
      "append-to-body": true,
      "name": "ClientName"
    },
    model: {
      value: (_vm.AddedClientName),
      callback: function($$v) {
        _vm.AddedClientName = $$v
      },
      expression: "AddedClientName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Pickup Pincode")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-pin' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupPincode),
      expression: "pickupPincode"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Pickup Pincode",
      "name": "pickupPincode"
    },
    domProps: {
      "value": (_vm.pickupPincode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pickupPincode = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Requested Pickup Date From ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupFromDate),
      expression: "pickupFromDate"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "date",
      "name": "pickupFromDate"
    },
    domProps: {
      "value": (_vm.pickupFromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pickupFromDate = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Requested Pickup Date To ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupToDate),
      expression: "pickupToDate"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "date",
      "name": "pickupToDate"
    },
    domProps: {
      "value": (_vm.pickupToDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pickupToDate = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onPageChange(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("   \n                                "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFilter
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])], 1)])])])], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "color": "black",
      "padding": "5px 0px 5px 0px"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v("Filtered Records: " + _vm._s(_vm.totalCount))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v("Selected Records: " + _vm._s(_vm.selectedRequest.length))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('b-input-group', [(_vm.tripStatus != 'closed') ? _c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button",
      "title": "Assign To The Trip"
    },
    on: {
      "click": _vm.addRequestToTrip
    }
  }, [_vm._v("\n                                Assign To The Trip")]) : _vm._e(), _vm._v(" "), (_vm.tripStatus == 'closed') ? _c('button', {
    staticClass: "-btn btn-success disabled",
    staticStyle: {
      "float": "right",
      "opacity": "0.5"
    },
    attrs: {
      "type": "button",
      "title": _vm.tripStatus == 'start' ? '' : 'Trip is in closed condition, Pickup Request for pickup can be added only when the trip is in created or started state'
    }
  }, [_vm._v("\n                                  Assign To The Trip")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.requesterr))])], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-y": "auto",
      "max-height": "400px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isAllSelected),
      expression: "isAllSelected"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isAllSelected) ? _vm._i(_vm.isAllSelected, null) > -1 : (_vm.isAllSelected)
    },
    on: {
      "click": _vm.selectAll,
      "__c": function($event) {
        var $$a = _vm.isAllSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isAllSelected = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isAllSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isAllSelected = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr enabled"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Requested Pickup ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Pickup Address")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Pickup Pincode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Number of MPS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Total Physical Weight (kg)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Request Creation Date ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Request Pickup Date ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Re-schedule Date ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Shipment Tags")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.tableItems), function(data) {
    return [_c('tr', {
      class: {
        "text-primary": true,
        "rowdisable": data.disable == 1
      },
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "title": data.disable == 1 ? data.disablereason : ''
      }
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedRequest),
        expression: "selectedRequest"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": data.disable == 1
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.selectedRequest) ? _vm._i(_vm.selectedRequest, data) > -1 : (_vm.selectedRequest)
      },
      on: {
        "click": _vm.select,
        "__c": function($event) {
          var $$a = _vm.selectedRequest,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedRequest = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selectedRequest = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedRequest = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr"
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ClientName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.PickupAddress))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.PickupPincode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.NumberofMPS))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.PickupWeights))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.RequestCreationDate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.RequestPickupDate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.Rescheduleddate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.isopenpickupdelivery == 1) ? _c('b-badge', {
      staticClass: "common-otp-primary",
      attrs: {
        "variant": "secondary",
        "title": "Open Pickup"
      }
    }, [_vm._v("OP")]) : _vm._e(), _vm._v(" "), _c('br')], 1)])]
  })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('pagination', {
    staticClass: "pagination",
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalCount,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  })], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTabpickup[2]),
      expression: "accordianTabpickup[2]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "Addedtothetrip",
      "id": "pickupchck2"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTabpickup[2]) ? _vm._i(_vm.accordianTabpickup[2], null) > -1 : (_vm.accordianTabpickup[2])
    },
    on: {
      "click": function($event) {
        _vm.PickuptoggleCheck(2)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTabpickup[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTabpickup[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTabpickup[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTabpickup, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "pickupchck2"
    }
  }, [_vm._v("Added to the trip(" + _vm._s(this.totalCount2) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse1",
      "aria-expanded": "true",
      "title": "Search Filter"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Pickup Request ID ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PICKUPREQUEST),
      expression: "PICKUPREQUEST"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "PICKUPREQUEST",
      "placeholder": "Pickup Request"
    },
    domProps: {
      "value": (_vm.PICKUPREQUEST)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnly($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.PICKUPREQUEST = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Client Short/ Display Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.companyNamelist,
      "placeholder": "Select Client",
      "append-to-body": true,
      "name": "ClientName"
    },
    model: {
      value: (_vm.AddedClientNametemp),
      callback: function($$v) {
        _vm.AddedClientNametemp = $$v
      },
      expression: "AddedClientNametemp"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.AddedToTripRequest()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("   \n                                "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])], 1)])])])], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "color": "black",
      "padding": "0px 0px 5px 0px"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v("Filtered Records: " + _vm._s(_vm.totalCount2))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v("Selected Records: " + _vm._s(_vm.selectedRemoveRequest.length))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('b-input-group', [(_vm.tripStatus == 'created') ? _c('button', {
    staticClass: "-btn btn-success",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Remove From Trip"
    },
    on: {
      "click": _vm.removeFromTrip
    }
  }, [_vm._v("\n                                Remove From Trip")]) : _vm._e(), _vm._v(" "), (_vm.tripStatus != 'created') ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "disabled": "",
      "title": "Remove From The Trip"
    }
  }, [_vm._v("Remove From Trip")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.removerequesterr))])], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-y": "auto",
      "max-height": "400px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isAllAddedSelected),
      expression: "isAllAddedSelected"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isAllAddedSelected) ? _vm._i(_vm.isAllAddedSelected, null) > -1 : (_vm.isAllAddedSelected)
    },
    on: {
      "click": _vm.selectAllAdded,
      "__c": function($event) {
        var $$a = _vm.isAllAddedSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isAllAddedSelected = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isAllAddedSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isAllAddedSelected = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr enabled"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Requested Pickup ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Pickup Address")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Pickup Pincode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Number of MPS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Total Physical Weight (kg)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Request Creation Date ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Request Pickup Date ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Shipment Tags")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.tableItems2), function(data) {
    return [_c('tr', {
      staticClass: "text-primary",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedRemoveRequest),
        expression: "selectedRemoveRequest"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.selectedRemoveRequest) ? _vm._i(_vm.selectedRemoveRequest, data) > -1 : (_vm.selectedRemoveRequest)
      },
      on: {
        "click": _vm.selectRemove,
        "__c": function($event) {
          var $$a = _vm.selectedRemoveRequest,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedRemoveRequest = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selectedRemoveRequest = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedRemoveRequest = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ClientName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.PickupAddress))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.PickupPincode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.NumberofMPS))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.PickupWeights))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.RequestCreationDate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.RequestPickupDate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.isopenpickupdelivery == 1) ? _c('b-badge', {
      staticClass: "common-otp-primary",
      attrs: {
        "variant": "secondary",
        "title": "Open Pickup"
      }
    }, [_vm._v("OP")]) : _vm._e(), _vm._v(" "), _c('br')], 1)])]
  })], 2)])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('pagination', {
    staticClass: "pagination",
    attrs: {
      "total-pages": _vm.totalPage2,
      "total": _vm.totalCount2,
      "per-page": _vm.pageLimit2,
      "current-page": _vm.currentPage2
    },
    on: {
      "pagechanged": _vm.onPageChange2
    }
  })], 1)], 1)])])]) : _vm._e()])], 1)])])], 1) : _vm._e(), _vm._v(" "), (_vm.startTrip == true) ? _c('div', [_c('start-trip', {
    attrs: {
      "parentOBJ": _vm.parentData
    },
    on: {
      "goBackToParent": _vm.callParent
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.showRouteSelection = false
      }
    },
    model: {
      value: (_vm.showRouteSelection),
      callback: function($$v) {
        _vm.showRouteSelection = $$v
      },
      expression: "showRouteSelection"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Select Routes")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.showRouteModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "routeselection",
    staticStyle: {
      "justify-content": "space-around"
    }
  }, [_c('div', [_vm._v("Routes")]), _vm._v(" "), _c('div', [_vm._v("Selected Routes\n            "), _c('span', {
    staticClass: "cutomtooltip"
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cutomtooltiptext"
  }, [_vm._v("\n                Drag and Drop Selected routes to set priority.\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "routeselection"
  }, [_c('div', {
    staticClass: "avilableroute"
  }, _vm._l((_vm.routeDetailsList), function(element) {
    return _c('div', {
      key: element.id,
      staticClass: "list-item checkbox list-item-flex"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      staticStyle: {
        "position": "none"
      },
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": element.selected
      },
      on: {
        "change": function($event) {
          _vm.routeSelect($event, element)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])]), _vm._v(" "), _c('label', {
      attrs: {
        "for": "1"
      }
    }, [_vm._v(" " + _vm._s(element.routename))]), _vm._v(" "), _c('span', {
      staticClass: "cutomtooltip"
    }, [_c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cutomtooltiptext"
    }, [_c('p', [_vm._v("Client : " + _vm._s(element.clientname))]), _vm._v(" "), _c('p', [_vm._v("FM Pincodes: " + _vm._s(element.fm))]), _vm._v(" "), _c('p', [_vm._v("LM Pincodes: " + _vm._s(element.lm))])])])])
  })), _vm._v(" "), _c('draggable', {
    staticClass: "selectedroute flip-transition",
    attrs: {
      "group": "baroute"
    },
    model: {
      value: (_vm.selectedroute),
      callback: function($$v) {
        _vm.selectedroute = $$v
      },
      expression: "selectedroute"
    }
  }, _vm._l((_vm.selectedroute), function(element, index) {
    return _c('div', {
      key: element.id,
      staticClass: "list-item list-item-drag list-item-flex"
    }, [_vm._v("Prority " + _vm._s(index + 1) + " : " + _vm._s(element.routename) + "\n              ")])
  }))], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "10px",
      "margin-right": "37px"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.selectedroute.length == 0
    },
    on: {
      "click": function($event) {
        _vm.showmodal('show')
      }
    }
  }, [_vm._v("Auto Allocate Shipment")]), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showRouteModal
    }
  }, [_vm._v("Cancel")])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.showAllocationModal = false
      }
    },
    model: {
      value: (_vm.showAllocationModal),
      callback: function($$v) {
        _vm.showAllocationModal = $$v
      },
      expression: "showAllocationModal"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Auto Allocation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeAllocationModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', [_vm._v("Status : "), (!_vm.forcestop && !_vm.forcestopBtn) ? _c('span', [_vm._v(_vm._s(_vm.allocationstatus))]) : _vm._e(), _vm._v(" "), (_vm.forcestop || _vm.forcestopBtn) ? _c('span', [_vm._v("Completed")]) : _vm._e()]), _vm._v(" "), _c('div', [_vm._v("Vehicle Weight : " + _vm._s(_vm.VehicleCapacity))]), _vm._v(" "), _c('div', [_vm._v("Allocated Weight : " + _vm._s(_vm.fixedToDecimalPlace(_vm.allocatedweight)))]), _vm._v(" "), _c('div', [_vm._v("FM Weight : " + _vm._s(_vm.fixedToDecimalPlace(_vm.allocatedweightfm)))]), _vm._v(" "), _c('div', [_vm._v("LM Weight : " + _vm._s(_vm.fixedToDecimalPlace(_vm.allocatedweightlm)))]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ShowNotallocated
    }
  }, [(_vm.showNotallocated) ? _c('span', [_vm._v("Close ")]) : _vm._e(), _vm._v("Not Allocated")])])]), _vm._v(" "), (_vm.showNotallocated) ? _c('div', [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("AWB")]), _vm._v(" "), _c('th', [_vm._v("Route")]), _vm._v(" "), _c('th', [_vm._v("Allocation Type")]), _vm._v(" "), _c('th', [_vm._v("Comment")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.notautoallocated), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.AWB))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.routename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.shipmenttype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.status))])])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Routes")]), _vm._v(" "), _c('th', [_vm._v("Trip Allocation")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.selectedroute), function(element, index) {
    return _c('tr', {
      key: element.id
    }, [_c('td', [_vm._v(_vm._s(element.routename))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "min-width": "350px"
      }
    }, [(!_vm.currentroute[index]) ? _c('span', {
      staticStyle: {
        "background-color": "yellow",
        "padding": "5px"
      }
    }, [_vm._v(" Pending")]) : _vm._e(), _vm._v(" "), (_vm.currentroute[index] && _vm.currentroute[index] == 'Allocation In Progress') ? _c('span', {
      staticClass: "allocation-inprogress",
      staticStyle: {
        "padding": "5px"
      }
    }, [_vm._v(_vm._s(_vm.currentroute[index]))]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.currentroute[index] && _vm.currentroute[index] == 'Completed') ? _c('span', {
      staticStyle: {
        "background-color": "greenyellow",
        "padding": "5px"
      }
    }, [_vm._v(_vm._s(_vm.currentroute[index]))]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.currentroute[index] && _vm.currentroute[index] == 'Stopped') ? _c('span', {
      staticStyle: {
        "background-color": "rgb(245, 136, 27)",
        "padding": "5px"
      }
    }, [_vm._v(_vm._s(_vm.currentroute[index]))]) : _vm._e()]), _vm._v(" "), ((_vm.allocatedToTrip[index] && _vm.allocatedToTrip[index].length > 0)) ? _c('div', [_vm._v(" " + _vm._s(_vm.allocatedToTrip[index].join(", ")))]) : _vm._e(), _vm._v(" "), ((_vm.allocatedToTrip[index] && _vm.allocatedToTrip[index].length == 0) && (_vm.currentroute[index] && (_vm.currentroute[index] == 'Completed' || _vm.currentroute[index] == 'Stopped'))) ? _c('div', [_vm._v(" No Shipment Found.")]) : _vm._e()])])
  }))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "10px",
      "margin-right": "37px"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.stopAutoallocation
    }
  }, [_vm._v("Stop")]), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeAllocationModal
    }
  }, [_vm._v("Cancel")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "custom-modal",
    staticStyle: {
      "overflow-y": "initial"
    }
  }, [_c('div', {
    staticClass: "custom-modal-content",
    staticStyle: {
      "height": "83vh",
      "overflow-y": "auto"
    }
  }, [_c('div', [_c('span', {
    staticClass: "custom-modal-close-button",
    on: {
      "click": function($event) {
        _vm.showmodal('close')
      }
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "32px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', [_vm._v("Status : "), (!_vm.forcestop && !_vm.forcestopBtn) ? _c('span', [_vm._v(_vm._s(_vm.allocationstatus))]) : _vm._e(), _vm._v(" "), (_vm.forcestop || _vm.forcestopBtn) ? _c('span', [_vm._v("Completed")]) : _vm._e()]), _vm._v(" "), _c('div', [_vm._v("Vehicle Weight : " + _vm._s(_vm.VehicleCapacity))]), _vm._v(" "), _c('div', [_vm._v("FM Allocated Weight : "), _c('span', {
    staticClass: "text-success",
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.fixedToDecimalPlace(_vm.allocatedweightfm)))])]), _vm._v(" "), _c('div', [_vm._v("LM Allocated Weight : "), _c('span', {
    staticClass: "text-success",
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.fixedToDecimalPlace(_vm.allocatedweightlm)))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#2c3e50",
      "display": "flex",
      "flex-direction": "column",
      "align-items": "center"
    }
  }, [(_vm.loaderFlag || _vm.saveallocationflag) ? _c('div', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  })]) : _vm._e(), _vm._v(" "), (_vm.loaderFlag || _vm.saveallocationflag) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [(!_vm.forcestopBtn) ? _c('span', [_vm._v("Allocation In Progress")]) : _vm._e(), _vm._v(" "), (_vm.forcestopBtn) ? _c('span', {
    staticStyle: {
      "color": "rgb(251, 91, 91)"
    }
  }, [_vm._v("Stoping allocation. Please wait ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.selectedroute[_vm.currentrouteindex]) ? _c('div', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#2c3e50"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loaderFlag && !_vm.saveallocationflag) ? _c('div', [(_vm.allocationstopmessage == 'Auto-allocation completed.') ? _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.allocationstopmessage))]) : _vm._e(), _vm._v(" "), (_vm.allocationstopmessage != 'Auto-allocation completed.') ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.allocationstopmessage))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "custom-tabs",
    staticStyle: {
      "margin-top": "50px"
    }
  }, _vm._l((_vm.selectedroute), function(element, index) {
    return _c('div', {
      key: element.id,
      staticClass: "customtab"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": index
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "customtab-label",
      attrs: {
        "for": index
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "justify-content": "space-between",
        "width": "93%",
        "color": "#dbdbdb"
      }
    }, [_c('div', {
      staticClass: "customtab-label-div1"
    }, [_vm._v(_vm._s(element.routename))]), _vm._v(" "), _c('div', {
      staticClass: "customtab-label-div2"
    }, [_c('span', [_vm._v("Status:")]), _vm._v(" "), (!_vm.currentroute[index]) ? _c('span', [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (_vm.currentroute[index]) ? _c('span', [_vm._v(_vm._s(_vm.currentroute[index]))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "customtab-label-div3"
    }, [_c('span', [_vm._v("Waybill Allocated:")]), _vm._v(" "), (_vm.allocatedToTrip[index]) ? _c('span', [_vm._v(_vm._s(_vm.allocatedToTrip[index].length))]) : _vm._e(), _vm._v(" "), (!_vm.allocatedToTrip[index]) ? _c('span', [_vm._v("0")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "customtab-content"
    }, [((_vm.allocatedToTripFm[index] && _vm.allocatedToTripFm[index].length > 0)) ? _c('div', {
      staticStyle: {
        "background-color": "#0086ff12",
        "padding": "10px",
        "margin-bottom": "8px",
        "border-top": "1px solid #0086ff54"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "600",
        "margin-bottom": "10px"
      }
    }, [_vm._v("First Mile Allocated Waybill: " + _vm._s(_vm.allocatedToTripFm[index].length) + " ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "display": "block"
      }
    }, [_vm._v(" " + _vm._s(_vm.allocatedToTripFm[index].join(", ")))])]) : _vm._e(), _vm._v(" "), ((_vm.allocatedToTripLm[index] && _vm.allocatedToTripLm[index].length > 0)) ? _c('div', {
      staticStyle: {
        "background-color": "#0086ff12",
        "padding": "10px",
        "border-top": "1px solid #0086ff54"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "600",
        "margin-bottom": "10px"
      }
    }, [_vm._v("Last Mile Allocated Waybill: " + _vm._s(_vm.allocatedToTripLm[index].length) + " ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "display": "block"
      }
    }, [_vm._v(" " + _vm._s(_vm.allocatedToTripLm[index].join(", ")))])]) : _vm._e(), _vm._v(" "), ((_vm.allocatedToTrip[index] && _vm.allocatedToTrip[index].length == 0) && (_vm.currentroute[index] && (_vm.currentroute[index] == 'Completed' || _vm.currentroute[index] == 'Stopped'))) ? _c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [((_vm.allocatedToTrip[index] && _vm.allocatedToTrip[index].length == 0) && (_vm.currentroute[index] && (_vm.currentroute[index] == 'Completed' || _vm.currentroute[index] == 'Stopped'))) ? _c('span', [_vm._v(" No Shipment Found.")]) : _vm._e()]) : _vm._e()])])
  }))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [(!_vm.showNotallocated) ? _c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ShowNotallocated
    }
  }, [_vm._v("Not Allocated "), (_vm.notautoallocated.length > 0) ? _c('spna', {
    staticStyle: {
      "font-weight": "900"
    }
  }, [_vm._v("(" + _vm._s(_vm.notautoallocated.length) + ")")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showNotallocated) ? _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ShowNotallocated
    }
  }, [_vm._v("Close Not Allocated "), (_vm.notautoallocated.length > 0) ? _c('spna', {
    staticStyle: {
      "font-weight": "900"
    }
  }, [_vm._v("(" + _vm._s(_vm.notautoallocated.length) + ")")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.loaderFlag && !_vm.saveallocationflag) ? _c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showmodal('close')
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), (_vm.loaderFlag || _vm.saveallocationflag) ? _c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.stopAutoallocation
    }
  }, [_vm._v("Stop")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showmodal('close')
      }
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), (_vm.showNotallocated) ? _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.notautoallocated.length == 0) ? _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "font-family": "Roboto,sans-serif",
      "font-size": "15px",
      "color": "#2c3e50"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("No Shipment Found.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.notautoallocated), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.AWB))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.routename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.shipmenttype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.status))])])
  })], 2)])]) : _vm._e()])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("AWB")]), _vm._v(" "), _c('th', [_vm._v("Route")]), _vm._v(" "), _c('th', [_vm._v("Allocation Type")]), _vm._v(" "), _c('th', [_vm._v("Comment")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9ad55a4","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/TripManagement/CreateTripManagement/CreateTripManagement.component.html
// module id = 1362
// module chunks = 3